import { useEffect, useState } from "react";
import clsx from "clsx";
import {
  DEFAULT_TAX_RATE,
  isPresetTaxRate,
  TAX_RATE_PRESETS,
} from "@/lib/articleConstants";

export interface TaxRateSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  id?: string;
}

export function TaxRateSelect({ value, onChange, disabled, id }: TaxRateSelectProps) {
  const [customMode, setCustomMode] = useState(() => !isPresetTaxRate(value));
  const isCustom = customMode || !isPresetTaxRate(value);
  const selectValue = isCustom ? "custom" : value;

  useEffect(() => {
    setCustomMode(!isPresetTaxRate(value));
  }, [value]);

  function onSelectChange(next: string) {
    if (next === "custom") {
      setCustomMode(true);
      if (isPresetTaxRate(value)) {
        onChange(DEFAULT_TAX_RATE);
      }
      return;
    }
    setCustomMode(false);
    onChange(next);
  }

  function selectPreset(presetValue: string) {
    setCustomMode(false);
    onChange(presetValue);
  }

  return (
    <div className="space-y-3">
      <select
        id={id}
        disabled={disabled}
        className="eh-select-input"
        value={selectValue}
        onChange={(e) => onSelectChange(e.target.value)}
      >
        {TAX_RATE_PRESETS.map((preset) => (
          <option key={preset.value} value={preset.value}>
            {preset.label} – {preset.description}
          </option>
        ))}
        <option value="custom">Individuell …</option>
      </select>

      <div className="flex flex-wrap gap-2">
        {TAX_RATE_PRESETS.map((preset) => (
          <button
            key={preset.value}
            type="button"
            disabled={disabled}
            aria-pressed={!isCustom && value === preset.value}
            className={clsx(
              "rounded-full border px-3 py-1 text-xs font-medium transition-colors",
              !isCustom && value === preset.value
                ? "border-accent bg-accent/10 text-accent"
                : "border-separator text-label-secondary hover:border-accent/40 hover:text-label",
              disabled && "cursor-not-allowed opacity-60",
            )}
            onClick={() => selectPreset(preset.value)}
          >
            {preset.label}
          </button>
        ))}
      </div>

      {isCustom ? (
        <label className="flex flex-col gap-1 text-sm">
          <span className="text-label-secondary">Individueller Steuersatz (%)</span>
          <input
            type="number"
            min="0"
            max="100"
            step="0.01"
            disabled={disabled}
            className="eh-input w-32"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        </label>
      ) : null}
    </div>
  );
}
